import {
  useSelectFilterLogic,
  type UseSelectFilterLogicProps,
} from "~/GearboxSelectionAssistant/components/CharacteristicsFilter/components/useSelectFilterLogic";
import { CalendarLikeSelect } from "~/common/components/Select/CalendarLikeSelect";
import { type CSSProperties } from "react";

type Props = Omit<UseSelectFilterLogicProps, "multiselect"> & {
  className?: string;
  onChange: (code: string[]) => void;
  value: string[];
  style?: CSSProperties;
};

export const MultiSelectFilter = ({ className, ...rest }: Props) => {
  const { name, items, trackingCode } = useSelectFilterLogic({ ...rest, multiselect: true });

  return (
    <CalendarLikeSelect
      {...rest}
      itemsPerRow={4}
      className={className}
      label={name}
      value={rest.value}
      // TODO - Check after m-ui update
      onChange={(e) => rest.onChange(e.target.value as string[])}
      multiple={true}
      renderValue={(selected) =>
        (selected as string[]).map((code) => items.find((item) => item.code === code)!.name).join(", ")
      }
      MenuProps={{
        "tracking-aux-section-marker": trackingCode,
      }}
    >
      {items.map((item) => (
        <CalendarLikeSelect.Item
          key={item.code}
          value={item.code}
          disabled={item.disabled}
          tracking-aux-option-marker={item.trackingCode}
        >
          {item.name}
        </CalendarLikeSelect.Item>
      ))}
    </CalendarLikeSelect>
  );
};
